var Acre = "Acri";
var Alagoas = "Alagoas";
var Amazonas = "Amazzonia";
var Bahia = "Bahia";
var Pernambuco = "Pernambuco";
var Roraima = "Roraima";
var Sergipe = "Sergipe";
var Tocantins = "Tocantins";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "Amapá",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "Ceará",
	"Federal District": "Distretto Federale",
	"Espírito Santo": "Espírito Santo",
	"Goiás": "Goiás",
	"Maranhão": "Maranhão",
	"Mato Grosso": "Mato Grosso",
	"Mato Grosso do Sul": "Mato Grosso do Sul",
	"Minas Gerais": "Minas Gerais",
	"Pará": "Pará",
	"Paraíba": "Paraíba",
	"Paraná": "Paraná",
	Pernambuco: Pernambuco,
	"Piauí": "Piauí",
	"Rio de Janeiro": "Rio de Janeiro",
	"Rio Grande do Norte": "Rio Grande do Norte",
	"Rio Grande do Sul": "Rio Grande do Sul",
	"Rondônia": "Rondônia",
	Roraima: Roraima,
	"Santa Catarina": "Santa Catarina",
	"São Paulo": "San Paolo",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
